export const TICKET_DISASSOCIATED = 'TICKET_DISASSOCIATED';